/** Get Summary Dashboard data */
export const ROUTE_LIST_API_SUCCESS = "ROUTE_LIST_API_SUCCESS";
export const ROUTE_LIST_API_FAIL = "ROUTE_LIST_API_FAIL";
export const ROUTE_LIST_DATA = "ROUTE_LIST_DATA";
export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE"